import React from "react";
import { useTranslation } from "react-i18next";

import TeamList from "@wc/domain/teams/components/team-list";
import usePageTitle from "@wc/ui/hooks/page-title";

/**
 * @returns {React.ReactElement} The teams page
 */
export default function TeamsPage() {
  const { t } = useTranslation();
  usePageTitle(t("team.listTitle"));

  return <TeamList />;
}
